import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Icon, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  Cards,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import Card from "./Card";
import RemoveModal from "./RemoveModal";

const ListCertificadoCurso = (props) => {
  const [removeModal, setRemoveModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [certificados, setCertificados] = useState([]);
  const [total, setTotal] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const removeModalOpen = (name, id) => {
    setSelectedItem({ name, id });
    setRemoveModal(true);
  };

  const deleteCertificado = useCallback(
    (id) => {
      api.delete(`/certificados/curso/templates/${id}`).then((res) => {
        const newCertificados = [...certificados].filter(
          (certificado) => certificado.id !== id
        );
        setCertificados(newCertificados);
        swal(res.data.msg, "", "success");
      });
    },
    [certificados]
  );

  useEffect(() => {
    api
      .get("certificados/curso/templates/1")
      .then((res) => {
        setCertificados([...certificados, ...res.data.certificados]);
        setTotal(res.data.count);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os Certificados", err, "").then((res) =>
          props.history.push("/admin")
        );
      });
  }, []);

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Certificados</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar Certificado..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />

              <CreateButton to="/admin/ead/certificados/cursos/criar">
                Criar
              </CreateButton>
            </ContainerInputSearch>

            {certificados.length > 0 ? (
              <Cards>
                {certificados
                  .filter((certificado) =>
                    certificado.curso.curso
                      .toLowerCase()
                      .includes(search.toLowerCase())
                  )
                  .map((certificado, index) => (
                    <Card
                      key={index}
                      remove={removeModalOpen}
                      title={certificado.curso.curso}
                      img={certificado.url_image}
                      id={certificado.id}
                    />
                  ))}
              </Cards>
            ) : (
              <h1>Nenhum Certificado encontrado</h1>
            )}
          </Content>
        )}
      </Container>

      <RemoveModal
        deleteCertificado={deleteCertificado}
        handler={setRemoveModal}
        active={removeModal}
        item={selectedItem}
      />
    </>
  );
};

export default withRouter(ListCertificadoCurso);
